import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DateFns } from '@utils';
import { AccountDbQueryService } from '../services/account-db-query.service';

export interface PugCurrentProgramsDialogParams {
  programUserGroupId: string;
}

interface CurrentProgramRow {
  programId: string;
  programName: string;
  programTypeName: string;
  startDate: string;
  endDate: string;
  activeStatusName: string;
}

@Component({
  selector: 'prox-pug-current-programs-dialog',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  template: `
    <div class="flex h-full flex-col">
      @if (isLoading) {
        <div class="flex flex-1 items-center justify-center">
          <i class="pi pi-spin pi-spinner text-2xl"></i>
        </div>
      } @else if (rows.length === 0) {
        <div class="flex flex-1 items-center justify-center text-gray-500">
          No current programs.
        </div>
      } @else {
        <div class="flex-1 overflow-auto">
          <table class="w-full text-sm">
            <thead class="sticky top-0 bg-gray-100">
              <tr class="text-left">
                <th class="px-3 py-2 font-semibold">Program</th>
                <th class="px-3 py-2 font-semibold">Type</th>
                <th class="px-3 py-2 font-semibold">Start</th>
                <th class="px-3 py-2 font-semibold">End</th>
                <th class="px-3 py-2 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody>
              @for (row of rows; track row.programId) {
                <tr class="border-t">
                  <td class="px-3 py-2">{{ row.programName }}</td>
                  <td class="px-3 py-2">{{ row.programTypeName }}</td>
                  <td class="px-3 py-2">{{ row.startDate }}</td>
                  <td class="px-3 py-2">{{ row.endDate }}</td>
                  <td class="px-3 py-2">{{ row.activeStatusName }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      <div class="mt-3 flex justify-start border-t pt-3">
        <button pButton label="Close" class="p-button-sm" (click)="onClose()"></button>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
      }
    `,
  ],
})
export class PugCurrentProgramsDialogComponent implements OnInit {
  isLoading = true;
  rows: CurrentProgramRow[] = [];

  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private dbQueryService: AccountDbQueryService,
  ) {}

  async ngOnInit(): Promise<void> {
    const params = this.config.data as PugCurrentProgramsDialogParams;
    const data = await this.dbQueryService.getCurrentProgramsForPug(params.programUserGroupId);
    this.rows = data.map((d) => ({
      programId: d.ProgramId,
      programName: d.ProgramName,
      programTypeName: d.ProgramTypeName,
      startDate: d.StartDate ? DateFns.fmtDateShort(new Date(d.StartDate)) : '',
      endDate: d.EndDate ? DateFns.fmtDateShort(new Date(d.EndDate)) : '',
      activeStatusName: d.ActiveStatusName,
    }));
    this.isLoading = false;
  }

  onClose(): void {
    this.ref.close();
  }
}
